import type { ReactNode } from 'react'
import './Tooltip.css'

/**
 * A short explanation shown above (or, with `placement="right"`, beside) `children` on hover
 * or keyboard focus. Styled as a
 * popover (design.md 8.5). The text is also the wrapper's accessible description, so screen
 * readers hear it without hovering.
 */
export function Tooltip({ text, placement = 'top', children }: { text: string; placement?: 'top' | 'right'; children: ReactNode }) {
  return (
    <span className="tooltip-root" tabIndex={0} aria-label={text}>
      {children}
      <span className={`tooltip tooltip-${placement}`} role="tooltip" aria-hidden="true">{text}</span>
    </span>
  )
}
